import { TFunction } from "i18next";

export const energyEfficiencyClasses = [
  { label: "Nicht bekannt", value: "UNKNOWN" },
  { label: "EH40", value: "KW" },
  { label: "EH40 mit QNG", value: "QNG" },
];

export const sonderAfaForcedOptions = [
  { label: "Nicht bekannt", value: null },
  { label: "Nein", value: false },
  { label: "Ja", value: true },
];

export const priceGrowthRelationOptions = (t: TFunction) => [
  {
    label: t("calculator_form.price_growth_relation.finish_date"),
    value: CALCULATOR_STAGES.FINISH_STAGE,
  },
  {
    label: t("calculator_form.price_growth_relation.purchase_date"),
    value: CALCULATOR_STAGES.PURCHASE_STAGE,
  },
  {
    label: t("calculator_form.price_growth_relation.custom_date"),
    value: "CUSTOM",
  },
];

export const getGrowthDynamicOptions = (t: TFunction) => [
  {
    label: t("calculator_form.affected_enumeration_interval.1_year"),
    value: 1,
  },
  {
    label: t("calculator_form.affected_enumeration_interval.2_years"),
    value: 2,
  },
  {
    label: t("calculator_form.affected_enumeration_interval.3_years"),
    value: 3,
  },
  {
    label: t("calculator_form.affected_enumeration_interval.5_years"),
    value: 4,
  },
  {
    label: t("calculator_form.affected_enumeration_interval.10_years"),
    value: 5,
  },
];

export const getFamilyTaxableIncomeOptions = (t: TFunction) => [
  {
    label: t("calculator_form.marital_status.single"),
    value: false,
  },
  {
    label: t("calculator_form.marital_status.married"),
    value: true,
  },
];

export const getSplitTaxableIncomeOptions = (t: TFunction) => [
  {
    label: t("calculator_form.taxable_income.split"),
    value: true,
  },
  {
    label: t("calculator_form.taxable_income.individual"),
    value: false,
  },
];

export const DEFAULT_LOAN_RATE = 4;

export const MAX_APARTMENTS_LIMIT = 2;
export const MAX_PARKINGS_LIMIT = 2;
export const MAX_STAGES_LIMIT = 11;

export const CALCULATOR_OBJECT_TYPES = {
  APARTMENT: "APARTMENT",
  PARKING: "PARKING",
};

export const CALCULATOR_PARKING_TYPES = {
  PARKING_UNDERGROUND: "PARKING_UNDERGROUND",
  PARKING_GARAGE: "PARKING_GARAGE",
  PARKING_OUTDOOR: "PARKING_OUTDOOR",
};

export const CALCULATOR_TYPES = {
  BASIC: 'basic',
  STANDARD: "standard",
  LIMITED_PRO: "limitedPro",
  EXPERT: "expert",
};

export const CALCULATOR_STAGES = {
  START_STAGE: "START_STAGE",
  PURCHASE_STAGE: "PURCHASE_STAGE",
  RENTAL_INCOME_STAGE: "RENTAL_INCOME_STAGE",
  BUILDING_STAGE: "BUILDING_STAGE",
  FINISH_STAGE: "FINISH_STAGE",
};

export const CALCULATOR_SCENARIO_VARIANT = {
  DEFAULT: "default",
  POSITIVE: "positive",
  NEGATIVE: "negative",
  NEUTRAL: "neutral",
};
